/**
 * Veltrona — product card behaviour: colour swatch preview and quick view.
 */
(() => {
  'use strict';

  const V = window.Veltrona;

  /* Swatch preview: hovering or pressing a colour shows that variant's image. */
  const preview = (swatch) => {
    const card = swatch.closest('.card');
    const img = card?.querySelector('.card__img--primary');
    const src = swatch.dataset.swatchImage;
    if (!img || !src) return;
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.currentSrc || img.src;
      img.dataset.originalSrcset = img.getAttribute('srcset') || '';
    }
    img.removeAttribute('srcset');
    img.src = src;
    card.classList.add('is-previewing');
    card.querySelectorAll('.card__swatch').forEach((s) => s.classList.toggle('is-active', s === swatch));
  };

  document.addEventListener('pointerover', (e) => {
    const swatch = e.target.closest?.('.card__swatch[data-swatch-image]');
    if (swatch && e.pointerType === 'mouse') preview(swatch);
  });

  document.addEventListener('click', (e) => {
    const swatch = e.target.closest?.('.card__swatch');
    if (!swatch) return;
    e.preventDefault();
    preview(swatch);
  });

  /* Quick view: loads the quick-view section for the product into a dialog. */
  let dialogEl;
  const getDialog = () => {
    if (dialogEl) return dialogEl;
    dialogEl = document.createElement('vt-dialog');
    dialogEl.className = 'quick-view';
    dialogEl.innerHTML = `
      <dialog class="vt-dialog vt-dialog--center" aria-label="${V.strings.quickView || ''}">
        <div class="vt-dialog__scrim"></div>
        <div class="vt-dialog__panel color-scheme-1" style="--dialog-width: 104rem;">
          <button type="button" class="icon-btn quick-view__close" data-dialog-close aria-label="${V.strings.close || ''}">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>
          </button>
          <div class="quick-view__body" data-quick-view-body><div class="quick-view__loading skeleton"></div></div>
        </div>
      </dialog>`;
    document.body.appendChild(dialogEl);
    return dialogEl;
  };

  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest?.('[data-quick-view]');
    if (!trigger || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    const dialog = getDialog();
    const body = dialog.querySelector('[data-quick-view-body]');
    body.innerHTML = '<div class="quick-view__loading skeleton"></div>';
    dialog.open(trigger);
    try {
      const url = new URL(trigger.href, window.location.origin);
      const res = await fetch(`${url.pathname}?section_id=quick-view`);
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const content = doc.querySelector('[data-quick-view-content]');
      if (!content) throw new Error('missing');
      body.innerHTML = '';
      body.appendChild(content);
      V.Reveal.init(body);
      body.querySelectorAll('[data-reveal], [data-reveal-image]').forEach((el) => el.classList.add('is-revealed'));
      V.utils.focusable(body)[0]?.focus({ preventScroll: true });
    } catch (err) {
      window.location.href = trigger.href;
    }
  });

  document.addEventListener('veltrona:cart:added', () => {
    if (dialogEl?.isOpen) dialogEl.close();
  });
})();
